module.exports = __webpack_public_path__ + "img/partner.8154f216.png";